import Workspaces from "../../workspaces/Workspaces";
import { WazToolbar } from "../toolbar/WazToolbar";
import "./WazWorkspaceSettings.css";

export const WazWorkspaceSettings = () => {
    return (
        <div className="waz-workspace-settings">
            <WazToolbar />
            <div className="waz-workspace-settings-content">
                <Workspaces />
            </div>
        </div>
    );
};